<div
  class="notification_message"
  [ngClass]="{
    active: notification.progress === messageNotificationProgress.Unread
  }"
  [attr.data-id]="notification.id"
  (mouseenter)="
    notification.progress === messageNotificationProgress.Unread
      ? onMouseEnter()
      : null
  "
  (mouseleave)="
    notification.progress === messageNotificationProgress.Unread
      ? onMouseLeave()
      : null
  ">
  <div class="message_header">
    <img
      src="../../../../../../../assets/svg/logo_notifications.svg"
      alt="Logo Notifications" />
    <div class="message_header_data">
      <p>{{ notification.dateCreated | date: 'dd MMM yyyy, HH:mm' }}</p>
      <button mat-icon-button (click)="onDelete()">
        <img src="../../../../../../../assets/svg/closeBtn.svg" alt="Close" />
      </button>
    </div>
  </div>
  <div class="message_description">
    <p class="desc_text">
      {{ 'TYPE' | translate }}:
      <span class="desc_">{{
        notification.commercialDocumentProcessType
      }}</span>
    </p>
    <p class="desc_message">
      {{ 'UNREAD_MESSAGE_FROM' | translate }}
      <strong
        >{{
          notification.messageSentByUserFirstName +
            ' ' +
            notification.messageSentByUserLastName
        }}
      </strong>
      {{ 'IN' | translate }}
      {{ notification.entityName }}
      {{ 'CHAT_ROOM' | translate }}
    </p>
    <button class="message_view" (click)="routeToChart(notification)">
      {{ 'VIEW' | translate }}
    </button>
  </div>
</div>
